/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { additionalQuestionStore } from '../../axios/additionalQuestionStore'
import type {
	AdditionalQuestionStoreError,
	AdditionalQuestionStorePathParams,
	AdditionalQuestionStoreRequest,
	AdditionalQuestionStoreResponse,
} from '../../types/AdditionalQuestionStore'

export const additionalQuestionStoreMutationKey = () => [{ url: '/forms/:form/additional-questions' }] as const

export type AdditionalQuestionStoreMutationKey = ReturnType<typeof additionalQuestionStoreMutationKey>

export type AdditionalQuestionStoreVariables = {
	form: AdditionalQuestionStorePathParams['form']
	data: AdditionalQuestionStoreRequest
}

/** @see backend/nexus/modules/Form/Http/Controllers/AdditionalQuestionController.php AdditionalQuestionController::store */
export function useAdditionalQuestionStore<TContext = unknown>(
	options?: UseMutationOptions<
		AdditionalQuestionStoreResponse,
		AxiosError<AdditionalQuestionStoreError>,
		AdditionalQuestionStoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: additionalQuestionStoreMutationKey(),
		mutationFn: ({ form, data }: AdditionalQuestionStoreVariables) =>
			additionalQuestionStore(form, data, config).then(res => res.data),
		...options,
	})
}
